import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
export function AngelikaSturnTerminVereinbarenPage() {
  return <div className="min-h-screen bg-white" data-id="element-1065">
      <Header data-id="element-1066" />
      <main className="w-full pt-[152px]" data-id="element-1067">
        <div className="max-w-6xl mx-auto py-16 px-6 md:px-12" data-id="element-1068">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1069">
            Termin vereinbaren
          </h1>
          <div className="prose prose-lg max-w-none" data-id="element-1070">
            <p className="text-lg text-gray-600 mb-8" data-id="element-1071">
              Praxis im Aufbau. Einzeltermine werden in Absprache vergeben.
            </p>
            <p className="text-lg text-gray-600" data-id="element-1072">
              Kontaktieren Sie mich gerne per E-Mail:{' '}
              <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-1073">
                praxis@angelikasturny.com
              </a>
            </p>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-1074" />
    </div>;
}